import React from "react";

const GloablButton = React.forwardRef(function GloablButton(
  {
    width = "200px",
    height = "48px",
    backgroundColor = "#4072C8",
    text = "Button",
    className = "",
    type = "button",
    icon = null,
    iconPosition = "left",
    gap = "8px",
    borderRadius = "50px",
    border = "none",
    color = "#FFFFFF",
    fontWeight = 700,
    fontSize = "16px",
    lineHeight = "22.11px",
    textAlign = "center",
    padding = "0",
    boxShadow = "none",
    onClick,
    disabled = false,
  },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={className}
      onClick={onClick}
      disabled={disabled}
      style={{
        width,
        height,
        backgroundColor,
        border,
        borderRadius: borderRadius,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap,
        cursor: disabled ? "not-allowed" : "pointer",
        padding,
        boxShadow,
        opacity: disabled ? 0.6 : 1,
      }}
    >
      {icon && iconPosition === "left" ? (
        <span style={{ display: "flex", alignItems: "center" }}>{icon}</span>
      ) : null}
      <span
        style={{
          fontFamily: "Inter",
          fontWeight,
          fontSize,
          lineHeight,
          letterSpacing: "0%",
          color,
          textAlign,
          whiteSpace: "nowrap",
        }}
      >
        {text}
      </span>
      {icon && iconPosition === "right" ? (
        <span style={{ display: "flex", alignItems: "center" }}>{icon}</span>
      ) : null}
    </button>
  );
});

export default GloablButton;
